import Vue from "vue";
import Vuex from "vuex";
import authModule, { AuthState } from "./auth.store";
import userModule, { UserState } from "./user.store";
import mailboxModule, { MailboxState } from "@/store/mailbox.store";
import productModule, { ProductState } from "@/store/product.store";
import taskboardModule, { TaskBoardState } from "@/store/taskboard.store";
import navigationModule, { NavigationState } from "@/store/navigation.store";
import conditionModule, { ConditionState } from "@/store/condition.store";
import sectorModule, { SectorState } from "@/store/sector.store";
import templateModule, { TemplateState } from "@/store/template.store";
import warehouseModule, { WarehouseState } from "@/store/warehouse.store";
import palletModule, {PalletState} from "@/store/pallet.store";
import forwardingAgencyModule, {ForwardingAgencyState} from "@/store/forwardingAgency.store";
import steelTubeModule , { SteelTubeState } from "@/store/steeltube.store"
import woodFrameModule , { WoodframeState } from "@/store/woodframe.store"
import documentClassificationModule, { DocumentClassificationState } from "@/store/documentClassification.store";
import roleModule, { RoleState } from "@/store/role.store";

export interface RootState {
  auth: AuthState;
  user: UserState;
  mailbox: MailboxState;
  product: ProductState;
  taskboard: TaskBoardState;
  navigation: NavigationState;
  condition: ConditionState;
  sector: SectorState;
  template: TemplateState;
  warehouse: WarehouseState;
  palletModule: PalletState;
  forwardingAgency: ForwardingAgencyState;
  steelTube: SteelTubeState;
  woodFrame: WoodframeState;
  documentClassification: DocumentClassificationState;
  role: RoleState;
}

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: authModule,
    user: userModule,
    mailbox: mailboxModule,
    product: productModule,
    pallet: palletModule,
    taskboard: taskboardModule,
    navigation: navigationModule,
    condition: conditionModule,
    sector: sectorModule,
    template: templateModule,
    warehouse: warehouseModule,
    forwardingAgency: forwardingAgencyModule,
    steelTube: steelTubeModule,
    woodFrame: woodFrameModule,
    documentClassification: documentClassificationModule,
    role: roleModule
  },
});
